import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetGroupName = urlConfig.GetGroupName;
const GetGroupDataEdit = urlConfig.GetGroupDataEdit;
const MetaDataGroupStatusChange = urlConfig.MetaDataGroupStatusChange;
const CreateGroup = urlConfig.CreateGroup;

export const getMetaDataGroups = async (params: any) => {
  try {
    const response = await postCall(GetGroupName, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getGroupDataEdit = async (params: any) => {
  try {
    const response = await postCall(GetGroupDataEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const metaDataGroupStatusChange = async (params: any) => {
  try {
    const response = await postCall(MetaDataGroupStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createMetaDataGroup = async (params: any) => {
  try {
    const response = await postCall(CreateGroup, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
